//APPLICATION REPORT
export const getStatusClass = (status) => {
  if (status === "Demo") {
    return "bg-yellow-100 text-[#92400E] px-3 py-1 rounded-xl text-xs font-medium text-center";
  } else if (status === "Sale") {
    return "bg-[#D1FAE5] text-[#065F46] px-4 py-1 rounded-xl text-xs font-medium text-center";
  } else {
    return "bg-[#E0E7FF] text-[#3730A3] px-3 py-1 rounded-xl text-xs font-medium text-center ";
  }
};
//FIXME: status style for lead and no sale 

//purchase order 

export const getOrderStatusClass = (status) => {
  if (status === "Demo") {
    return "bg-yellow-100 text-[#92400E] px-4 py-1 rounded-xl text-xs font-medium text-center";
  } else if (status === "Submitted") {
    return "bg-[#D1FAE5] text-[#065F46] px-4 py-1 rounded-xl text-xs font-medium text-center";
  } else {
    return "bg-[#E0E7FF] text-[#3730A3] px-3 py-1 rounded-xl text-xs font-medium text-center ";
  }
};